import { useFormik } from 'formik';
import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CONSTANTS, LOCAL_STORAGE, ROLE_VALUE, STATUS_CODE } from '../../../common/constants';
import { useSpinnerContext } from '../../../contexts/SpinnerContext';
import { useToastContext } from '../../../contexts/ToastContext';
import XacThucLayout from '../../../layouts/xac-thuc';
import apiService from '../../../services/api.service';
import authService from '../../../services/auth.service';
import '../index.scss';
import './index.scss';
import { getFormErrorMessage, isFormFieldValid }  from 'components/HHQComponents';
function DangNhapComponent() {
    const history = useHistory();
    const { showToast } = useToastContext();
    const { setIsShowLoading } = useSpinnerContext();
    const [showPassword, setShowPassword] = useState({
        login: false,
        register: false,
        confirmRegister: false
    });

    useEffect(() => {
        if (authService.isLogin()) {
            history.push('/tong-quan');
        };
    }, [history]);

    const handleLogin = async (data: { userName: string, password: string }) => {
        if (data.userName && data.password) {
            setIsShowLoading(true);
            apiService.login(data.userName, data.password)
                .then(async function (response) {
                    if (response.data.statusCode === STATUS_CODE.SUCCESS) {
                        const data = response.data.data;
                        let roles: string[] = [];
                        if (data.roles && typeof data.roles === 'string') {
                            data.roles = JSON.parse(data.roles)
                            if (Array.isArray(data.roles)) {
                                roles = data.roles.map(t => t.role_id);
                                localStorage.setItem(LOCAL_STORAGE.ROLE, JSON.stringify(roles));
                            } else {
                                localStorage.setItem(LOCAL_STORAGE.ROLE, '[]');
                            }
                        } else {
                            localStorage.setItem(LOCAL_STORAGE.ROLE, '[]');
                        }
                        localStorage.setItem(CONSTANTS.LOGIN_TOKEN, data.token);
                        localStorage.setItem(CONSTANTS.LOGIN_DATA, JSON.stringify(data));
                        showToast({ severity: 'success', summary: 'Thông báo', detail: 'Đăng nhập thành công', life: 3000 });
                        // Lấy thông tin roles lần dầu đăng nhập
                        try {
                            const response = await apiService.getMenuRoleAcounts(data.id);
                            if (response.data.data.statusCode === STATUS_CODE.SUCCESS) {
                                localStorage.setItem(CONSTANTS.LOGIN_ROLES, JSON.stringify(response.data.data.data));
                                // Nếu có roles admin thì chuyển thẳng sang admin
                                if (response.data.data.data && Array.isArray(response.data.data.data) && response.data.data.data.filter(t => t.screen === 'admin').length) {
                                } else {
                                }
                            }
                            if (roles.includes(ROLE_VALUE.ADMIN) || roles.includes(ROLE_VALUE.TEACHER) || roles.includes(ROLE_VALUE.TEST)) {
                                history.push('/quan-tri');
                            } else {
                                const redirectUrl = sessionStorage.getItem(`redirect`);
                                if (redirectUrl) {
                                    sessionStorage.removeItem(`redirect`);
                                    history.push(redirectUrl);
                                }
                                else {
                                    history.push('/tai-khoan/khoa-hoc-cua-toi');
                                }
                            }
                        } catch (error) {
                            history.push('/');
                        }
                    } else {
                        showToast({ severity: 'error', summary: 'Thông báo', detail: response.data.error, life: 3000 });
                    }
                })
                .catch(function (error) {
                    showToast({ severity: 'error', summary: 'Thông báo', detail: 'Đăng nhập thất bại', life: 3000 });
                    console.error(error);
                })
                .finally(() => {
                    setIsShowLoading(false);
                });
        }
    }

    const loginForm = useFormik({
        initialValues: {
            userName: '',
            password: '',
        },
        validate: (data) => {
            let errors: any = {};

            if (!data.userName) {
                errors.userName = 'Nhập Tài khoản';
            }

            if (!data.password) {
                errors.password = 'Nhập mật khẩu';
            }
            return errors;
        },
        onSubmit: (data) => {
            handleLogin(data);
        }
    });

    return (
        <div className='dang-nhap'>
            <XacThucLayout>
                <div className="login-wrapper">
                    <div className="login-title">
                        <div className="login-title--left">
                            <h2> Đăng nhập </h2>
                        </div>
                        <div className="login-title--right">
                            <span className='subtitle'>Bạn chưa có tài khoản?</span>
                            <span className='register-now' onClick={() => history.push('/dang-ky')}>Đăng ký ngay</span>
                        </div>
                    </div>
                    <form onSubmit={loginForm.handleSubmit} className="p-fluid login-form">
                        <div className="form-group">
                            <div className="label">Tài khoản <span className='text-red-500'> *</span></div>
                            <div className="input">
                                <i className="pi pi-phone"></i>
                                <input type="userName" id="userName" name="userName" value={loginForm.values.userName} onChange={loginForm.handleChange} autoFocus className={classNames({ 'p-invalid': isFormFieldValid(loginForm, 'userName') })} />
                            </div>
                        </div>
                        <span className='ml-2'>
                            {getFormErrorMessage(loginForm, 'userName')}
                        </span>
                        <div className="form-group">
                            <div className="label">Mật khẩu <span className='text-red-500'> *</span></div>
                            <div className="input">
                                <i className="pi pi-unlock"></i>
                                <input id="password" name="password" type={showPassword.login ? "text" : "password"} value={loginForm.values.password} onChange={loginForm.handleChange} className={classNames({ 'p-invalid': isFormFieldValid(loginForm, 'password') })} />
                                {
                                    showPassword.login ? (
                                        <i className="pi pi-eye right" onClick={() => setShowPassword({ ...showPassword, login: false })}></i>
                                    ) : (
                                        <i className="pi pi-eye-slash right" onClick={() => setShowPassword({ ...showPassword, login: true })}></i>
                                    )
                                }
                            </div>
                        </div>
                        <span className='ml-2'>
                            {getFormErrorMessage(loginForm, 'password')}
                        </span>
                        <div className="login-title--right mobile">
                            <span className='subtitle'>Bạn chưa có tài khoản?</span>
                            <span className='register-now' onClick={() => history.push('/dang-ky')}>Đăng ký ngay</span>
                        </div>
                        <div className="login-forgot-password pointer hover-text-primary" onClick={() => history.push('/quen-mat-khau')}>
                            Quên mật khẩu?
                        </div>
                        <div className="login-actions">
                            <button type="submit">Đăng nhập</button>
                        </div>
                    </form>
                </div>
            </XacThucLayout>
        </div>
    );
}
export default DangNhapComponent;